import { CreatedAt } from '../Document/CreatedAt.js';
import { BlockLink } from './BlockLink.js';
import { GetStrTotal } from '../Functions/GetStrTotal.js';
import { UCFirst } from '../Functions/UCFirst.js';

export const BlockTitleExperiments = (props) => {
    /*
    Pages/Public/Experiments.js
    */
    const item = props.item;
    const total = props.total;
    const author = props.author;
    const authors = item.authors ? item.authors : [];
    let values = [
        { name: UCFirst(item.name) },
        { strTotal: `${total} ${GetStrTotal('experience', total)}` },
    ];
    return (
        <div className="block-title">
            <CreatedAt date={item.created} />
            <div className="title">
                <div className="title-name">{values[0].name}</div>
                <div className="title-total-label">{values[1].strTotal}</div>
                <div className="title-author">{author}</div>
                {authors.map((el, i) => {
                    return (
                        <BlockLink label="link-true" href={el.link} name={el.name} key={i} />
                    )
                })}
            </div>
        </div>
    )
}